import React from 'react';

import { ThemeProvider } from 'styled-components';

import { theme } from '@waglabs/base-theme';

import { WagLogin } from './components/WagLogin';
import { WagLogin as WagLoginLegacy } from './components/WagLogin/WagLoginLegacy';

import { FeatureFlag } from '../../constants';

const Login = () => (
  <>
    {FeatureFlag.SignInV2Enabled ? (
      <ThemeProvider theme={theme}>
        <WagLogin />
      </ThemeProvider>
    ) : (
      <WagLoginLegacy />
    )}
  </>
);

export default Login;
